export const SESSION_COOKIE = '_safari_session';
export const OVERRIDDEN_BY_COOKIE = '_safari_overridden_by_account';
export const OVERRIDDEN_USER_COOKIE = '_safari_overridden_user';
